module.exports = __webpack_public_path__ + "static/img/4380.7c201ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/4380.png
// module id = pLSx
// module chunks = 2